import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
export var NsGraphResize;
(function (NsGraphResize) {
    /** Command: 用于注册named factory */
    NsGraphResize.command = XFlowGraphCommands.GRAPH_RESIZE;
    /** hookName */
    NsGraphResize.hookKey = 'graphResize';
})(NsGraphResize || (NsGraphResize = {}));
let GraphResizeCommand = 
/** 画布resize命令 */
class GraphResizeCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const config = yield this.ctx.getGraphConfig();
            const clientHeight = config.rootContainer.clientHeight;
            const clientWidth = config.rootContainer.clientWidth;
            const result = yield hooks.graphResize.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { width = clientWidth, height = clientHeight } = handlerArgs;
                x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.resize(width, height);
                return {};
            }), 
            /** execute command 时创建的hook */
            runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphResizeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphResizeCommand.prototype, "init", null);
GraphResizeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphResize.command.id },
    })
    /** 画布resize命令 */
], GraphResizeCommand);
export { GraphResizeCommand };
//# sourceMappingURL=graph-resize.js.map